import { render, staticRenderFns } from "./RelationsInput.vue?vue&type=template&id=567cb830&"
import script from "./RelationsInput.vue?vue&type=script&lang=js&"
export * from "./RelationsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports